import { AvailabilityRulesGetters } from './partials/availability-rules'
import { AvailabilitySlotsGetters } from './partials/availability-slots'
import { LinkedCalendarsGetters } from './partials/linked-calendars'
import { PermissionGetters } from './partials/permissions'
import { SchedulingAssistantGetters } from './partials/scheduling-assistant'
import { convertMinutesToISOTime } from '@/utilities/date-utilities'

export const CalendarGetters = {
  ...PermissionGetters,
  ...AvailabilityRulesGetters,
  ...AvailabilitySlotsGetters,
  ...LinkedCalendarsGetters,
  ...SchedulingAssistantGetters,

  appointmentTypes: state => state.appointmentTypes,

  appointmentTypesDropdownOptions: state => state.appointmentTypes.map(at => {
    return {
      duration: convertMinutesToISOTime(at.duration),
      text: at.name,
      value: at.id,
    }
  }),

  isCalendarLoading: state => state.runningRequests !== 0,

  selectedCalendarDate: state => state.selectedCalendar.date,
  selectedCalendarEvents: state => state.selectedCalendar.events,
  selectedCalendarEventsCount: state => state.selectedCalendar.eventsCount,
  selectedCalendarUserId: state => state.selectedCalendar.userId,
  selectedCalendarTimezone: state => state.selectedCalendar.timezone,

  sharedCalendars: state => state.sharedCalendars,

  sharedCalendarsDropdownOptions: state => {
    return state.sharedCalendars.map(c => {
      return {
        text: `${c.first_name} ${c.last_name} (${c.login})`,
        value: c.user_id,
      }
    })
  },

  timezones: state => state.timezones,
  timezonesDropdownOptions: state => {
    return state.timezones.main.
      concat({ divider: true }).
      concat(state.timezones.other)
  },
}
